import React, { use, useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import { getCompany } from "state/slices/company";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import TransactionApprovalsSignatureTab from "components/TransactionApprovalsSignatureTab";
import { Constants } from "config/constants";

const TransactionApprovalsSignature = () => {
  const { trxId, companyId } = useParams();
  const dispatch = useDispatch();
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { transactions } = transactionUnderReview.items;
  const [transactionsForSignature, setTransactionsForSignature] = useState([]);
  useEffect(() => {
    if (transactions?.length > 0) {
      setTransactionsForSignature(
        transactions.filter(
          (transaction) =>
            transaction.status ===
              Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS.DIRECTOR_SIGNATURE ||
            transaction.status ===
              Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS.SHAREHOLDER_SIGNATURE
        )
      );
    }
  }, [transactions]);

  useEffect(() => {
    dispatch(
      getTransactionUnderReviewAsync({
        trxId,
      })
    );
    dispatch(
      getCompany({
        companyId,
        queryparams: {
          isDashboard: true,
        },
      })
    );
  }, [trxId]);

  if (transactionsForSignature?.length > 0) {
    return (
      <CompanyDashboardWrapper>
        <TransactionApprovalsSignatureTab />
      </CompanyDashboardWrapper>
    );
  } else {
    return <div>Loading...</div>;
  }
};

export default TransactionApprovalsSignature;
